import { Container, Grid, Typography } from '@mui/material';
import { $$bi } from '../../services/BiService/model';
import { useUnit } from 'effector-react';
import { createSearchParams } from 'react-router-dom';
import BiThumbnailCard from '../../components/BiThumbnailCard';
import CuratingMessage from './CuratingMessage';
import { UserDashboardStatus } from '../../services/BiService';

export default function DashboardsSigmaPage() {
  const sigmaInfo = useUnit($$bi.$sigmaInfo);
  const sigmaDashboardStatus = useUnit($$bi.$sigmaDashboardStatus);

  return (
    <Container id="dashboard-list-container">
      <Typography variant="h4" color="text.primary" sx={{ mb: 6 }}>
        Dashboards
      </Typography>
      {!sigmaInfo || sigmaDashboardStatus === UserDashboardStatus.USER_NOT_FULLY_SETUP ? (
        <CuratingMessage />
      ) : (
        <Grid container>
          {(sigmaInfo?.dashboards || [])
            .sort((a, b) => {
              const PINNED_ID = 'sigma-ai-dashboard-id';
              if (a.id === PINNED_ID) return -1;
              if (b.id === PINNED_ID) return 1;
              return a.title.localeCompare(b.title);
            })
            .map(dashboard => {
              const hrefParams = createSearchParams({ dashboardId: dashboard.id }).toString();
              const hrefUrl = `/dashboard?${hrefParams}`;
              return (
                <Grid item key={dashboard.id + '-grid'} xs={12} sm={6} md={4} lg={3}>
                  <BiThumbnailCard key={dashboard.id + '-card'} {...dashboard} link={hrefUrl} />
                </Grid>
              );
            })}
        </Grid>
      )}
    </Container>
  );
}
